import React, { useState } from 'react';
import TrackCard from './TrackCard.js';
import './PathCard.css';

function PathCard(props) {
    const [isCollapsed, setCollapsed] = useState(true)

    const handleClick = () => {
        setCollapsed(!isCollapsed)        
    }

    return (
        <div className = "pathcard">
            <p><b>Skill Path: </b><a href={ 'https://www.codecademy.com/learn/paths/' + props.path.slug} target="_blank" rel="noreferrer">{props.path.title}</a></p>
            <p><b>slug: </b>{props.path.slug}</p>             
            <p><b>Description: </b>{props.path.shortDescription}</p>
            <button onClick={handleClick}>{isCollapsed ? "Expand" : "Hide"} Tracks</button>
            <div hidden={isCollapsed}>
                {props.tracks.map(track => <TrackCard key={track.id} track = {track}/>)}
            </div>
        </div>
    )
}

export default PathCard;